import firebase from 'firebase'
import firebaseui from 'firebaseui'

const config = {
    apiKey: "AIzaSyCJhQjcniFfRwAeD3IJBKVTdOgdRvnmJNQ",
    authDomain: "onestop-9a4ff.firebaseapp.com",
    databaseURL: "https://onestop-9a4ff.firebaseio.com",
    storageBucket: "onestop-9a4ff.appspot.com",
    messagingSenderId: "851524429202"
}

firebase.initializeApp(config)

export const ref = firebase.database().ref()
export const firebaseAuth = firebase.auth
export const ui = new firebaseui.auth.AuthUI(firebaseAuth());




// WEBPACK FOOTER //
// ./src/config/constants.js